<template>
  <v-container>
    <div>
      <div class="text-center">
        <h2
          style="text-align: center; border-style: solid; border-radius: 50px"
        >
          2. Schritt: CSV Daten Upload - Adressen, Standorte, Schichten <br />
          (Hier werden Strecken aus den Adressen, Standorten und Schichten
          erstellt.) <br />
          WICHTIG! Bitte darauf achten, dass die Spaltennamen der CSV Datei den
          folgenden Konventionen entsprechen und Spalten, die nicht in der Liste
          sind, nicht ausgewählt werden: <br />
          <ul style="list-style-type: none">
            <li>ID-Spalte: "MA_ID", "ma_id", "ID" oder "id"</li>
            <li>Adress-Spalten: "Start-Straße", "Start-PLZ", "Start-Ort"</li>
            <li>
              Standort-Spalten: "Ziel-Straße", "Ziel-Hausnummer", "Ziel-PLZ",
              "Ziel-Ort"
            </li>
            <li>Schicht-Spalten: "Shift_arrival", "Shift_departure"</li>
          </ul>
        </h2>
      </div>
      <br />
      <v-row>
        <v-col>
          <label style="font-size: large"
            >2.1. Datei auswählen:
            <input
              type="file"
              accept=".csv"
              id="file"
              ref="file"
              v-on:change="handleFileUpload()"
            />
          </label>
        </v-col>
        <v-col class="text-right">
          <v-btn
            v-auth-click="{
              roles: ['simple-user', 'licence-manager'],
              message: 'Sie haben keine Berechtigung, eine Datei auszuwählen!',
            }"
            @click="addFiles"
            color="primary"
            rounded="xl"
            size="x-large"
            elevation="10"
            variant="tonal"
            block
          >
            <v-icon icon="mdi-paperclip"></v-icon>
            Datei wählen
          </v-btn>
        </v-col>
      </v-row>
      <br />
      <v-row>
        <v-col class="text-left">
          <h3>
            2.2. Relevante Spalten auswählen (bitte nur Straße, Hausnummer, PLZ,
            Ort und Geo-Koordinaten, falls vorhanden!):
          </h3>
          <ul style="list-style-type: none">
            <li v-for="(column, index) in selectedColumns" :key="index">
              <label>
                <input
                  type="checkbox"
                  v-model="column.selected"
                  @change="onColumnSelectionChange"
                />
                {{ column.name }}
              </label>
            </li>
          </ul>
        </v-col>
      </v-row>
      <br />
      <v-row>
        <v-col class="text-left"
          ><p style="font-size: large">
            2.3. Adressen überprüfen und in Datenbank speichern
          </p>
          <p>(Hier sind noch Korrekturen in den Adressfeldern möglich!)</p>
        </v-col>
        <v-col class="text-right">
          <v-btn
            @click="sendData"
            :disabled="!file"
            color="primary"
            rounded="xl"
            size="x-large"
            elevation="10"
            variant="tonal"
            block
          >
            <v-icon icon="mdi-database-marker-outline"></v-icon>
            Adressen speichern
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-container>
  <v-container>
    <h3 class="text-center mb-4">
      {{ tableTitle }}
    </h3>
    <v-pagination
      v-model="currentPage"
      :length="paginationLength"
      :total-visible="5"
      class="my-4"
    ></v-pagination>
    <table v-if="parsed || showPaths">
      <thead>
        <tr>
          <th
            v-for="header in tableHeaders"
            :key="'header-' + header"
            style="font-weight: bold"
          >
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowKey) in displayedData" :key="'row-' + rowKey">
          <td
            v-for="header in tableHeaders"
            :key="'row-' + rowKey + '-column-' + header"
          >
            <input v-model="row[getOriginalColumnName(header)]" />
          </td>
        </tr>
      </tbody>
    </table>
  </v-container>
  <div class="text-center">
    <v-dialog v-model="loadingPaths" width="auto">
      <v-card style="border-radius: 15px">
        <v-card-text>
          <v-row>
            <v-col class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
              <div>Strecken werden gespeichert.</div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="pathsPosted" width="auto">
      <v-card style="border-radius: 15px">
        <v-card-text
          >{{ newPaths.length }} neue Strecken erfolgreich gespeichert.
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            block
            @click="
              pathsPosted = false;
              loadingPaths = false;
            "
            >Schließen</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  <div class="text-center">
    <v-dialog v-model="loading" width="auto">
      <v-card style="border-radius: 15px">
        <v-card-text>
          <v-row>
            <v-col class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
              <div>
                Adressen, Standorte, Schichten und Strecken werden gespeichert.
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addressesPosted" width="auto">
      <v-card style="border-radius: 15px">
        <v-card-text>
          <h3>Neue Einträge:</h3>
          <ul>
            <li>Adressen: {{ newItems.addresses }}</li>
            <li>Standorte: {{ newItems.offices }}</li>
            <li>Schichten: {{ newItems.shifts }}</li>
            <li>Strecken: {{ newItems.paths }}</li>
          </ul>
          <h3>Bereits vorhandene Einträge:</h3>
          <ul>
            <li>Adressen: {{ existingItems.addresses }}</li>
            <li>Standorte: {{ existingItems.offices }}</li>
            <li>Schichten: {{ existingItems.shifts }}</li>
            <li>Strecken: {{ existingItems.paths }}</li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            block
            @click="
              addressesPosted = false;
              loading = false;
            "
            >Schließen</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Papa from "papaparse";
import { mapStores } from "pinia";
import { useOfficeStore } from "../store/officeStore";
import { useAuthStore } from "../store/authStore";

interface CSV_Result {
  path_id: number;
  origin_id: number;
  destination_id: number;
  shift_id: number;
  office_id: number;
}

interface Column {
  name: string;
  selected: boolean;
}

export default defineComponent({
  props: {
    selectedProjectId: {
      type: Number,
      default: 0,
    },
    selectedCompanyId: {
      type: Number,
      default: 0,
    },
    selectedOfficeId: {
      type: Number,
      default: 0,
    },
    selectedShiftId: {
      type: Number,
      default: 0,
    },
    companyOffices: {
      type: Array || null,
    },
    officeShifts: {
      type: Array || null,
    },
    // message: {
    //   type: String || null,
    // },
  },
  setup() {
    const authStore = useAuthStore();
    const officeStore = useOfficeStore();

    return {
      authStore,
      officeStore,
    };
  },
  data() {
    return {
      file: "" as unknown,
      csvContent: {
        meta: {
          fields: [],
        },
        data: [],
      } as any,
      currentPage: 1,
      currentPagePaths: 1,
      pageSize: 10,
      selectedColumns: [] as Column[],
      new_csv_results: [] as CSV_Result[],
      loading: false,
      loadingPaths: false,
      addressesPosted: false,
      addressesReady: false,
      parsed: false,
      uploadPercentage: 0,
      newPaths: [] as object[],
      postedPaths: [] as object[],
      tableColumns: ["id", "origin_id", "destination_id", "shift_id"],
      columnMapping: {
        id: "Strecken-ID",
        origin_id: "Startort-ID",
        destination_id: "Zielort-ID",
        shift_id: "Schicht-ID",
      },
      parsedData: [],
      pathsPosted: false,
      showPaths: false,
      message: "",
      newItems: {
        addresses: 0,
        offices: 0,
        shifts: 0,
        paths: 0,
      },
      existingItems: {
        addresses: 0,
        offices: 0,
        shifts: 0,
        paths: 0,
      },
    };
  },
  emits: {
    "post-file": () => {
      return true;
    },
    "post-paths": () => {
      return true;
    },
  },
  computed: {
    tableHeaders() {
      if (this.parsed) {
        return this.csvContent.meta.fields;
      } else if (this.showPaths) {
        return this.tableColumns.map(
          (column) => this.columnMapping[column] || column,
        );
      }
      return [];
    },
    tableTitle() {
      if (this.parsed) {
        return "Inhalt CSV-Datei";
      } else if (this.showPaths) {
        return "Erstellte Strecken";
      }
      return "";
    },
    paginationLength() {
      if (this.parsed) {
        return Math.ceil(this.csvContent.data.length / this.pageSize);
      } else if (this.showPaths) {
        return Math.ceil(this.postedPaths.length / this.pageSize);
      }
      return 0;
    },
    displayedData() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      if (this.parsed) {
        return this.csvContent.data.slice(startIndex, endIndex);
      } else if (this.showPaths) {
        return this.postedPaths.slice(startIndex, endIndex);
      }
      return [];
    },
    displayedRows() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.csvContent.data.slice(startIndex, endIndex);
    },
    paginationLengthPaths() {
      return Math.ceil(this.postedPaths.length / this.pageSize);
    },
    displayedPaths() {
      const startIndex = (this.currentPagePaths - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.postedPaths.slice(startIndex, endIndex);
    },
    companies() {
      // @ts-ignore
      return this.officeStore.getCompanies;
    },
    selectedCompany() {
      // @ts-ignore
      let selected = this.companies.find((val: object) => {
        // @ts-ignore
        if (val.id) {
          // @ts-ignore
          if (val.id === this.selectedCompanyId) {
            return true;
          }
        }
        return false;
      });
      // return fallback
      if (!selected) {
        return { name: null, id: null };
      }
      return selected;
    },
  },
  methods: {
    reset() {
      // Reset data properties to their initial values
      this.file = null;
      this.parsedData = [];
      this.selectedColumns = [];
      this.csvContent = [];
      this.parsed = false;
      this.postedPaths = [];
      this.new_csv_results = [];
      this.newPaths = [];
      this.showPaths = false;
      this.pathsPosted = false;
      this.addressesPosted = false;
      this.addressesReady = false;
      this.loading = false;
      this.uploadPercentage = 0;
      this.$refs.file.value = null;
      // Add other data properties as needed
    },
    async postingPaths() {
      try {
        // @ts-ignore
        const paths = this.newPaths;
        const originIds = paths.map((path) => path.origin_id); // get origin_id's from newPaths

        // adds paths from newPaths to database
        this.officeStore.postPaths(paths);
        this.postedPaths = await this.officeStore.fetchPaths(
          this.selectedOfficeId,
          originIds,
        );
        console.log("Posted Paths in postingPaths: ", this.postedPaths);

        this.showPaths = true;
        this.pathsPosted = true;
      } catch (error) {
        // @ts-ignore
        console.error(error);
      }
    },

    async populateNewPaths() {
      // console.log("Parsed data in populateNewPaths: ", this.parsedData);

      this.new_csv_results.forEach((result) => {
        const newPath = {
          path_id: result.path_id,
          origin_id: result.origin_id as number,
          destination_id: result.destination_id,
          shift_id: result.shift_id,
          office_id: result.office_id,
        };

        this.newPaths.push(newPath);
      });
      console.log("New Paths in populateNewPaths: ", this.newPaths);

      return this.newPaths;
    },

    async created() {
      this.loadingPaths = true;
      await this.populateNewPaths();
      await this.postingPaths();
    },

    async sendData() {
      let file = this.csvContent.data;
      console.log("File in sendData: ", file);

      try {
        this.loading = true;

        console.log("Company ID in sendData: ", this.selectedCompanyId);
        console.log(
          "Selected Company in sendData: ",
          this.selectedCompany.name,
        );
        const dataToSend = {
          companyId: this.selectedCompanyId,
          companyName: this.selectedCompany.name,
          officeId: this.selectedOfficeId || undefined,
          shiftId: this.selectedShiftId || undefined,
          fileData: file,
        };

        // adds addresses from csv-file selection to database
        const response = await this.officeStore.postFile(dataToSend);

        // Extract stats from the response
        const stats = response.find((item) => item.stats)?.stats || {};

        this.newItems = {
          addresses: stats.new_addresses || 0,
          offices: stats.new_offices || 0,
          shifts: stats.new_shifts || 0,
          paths: stats.new_paths || 0,
        };

        this.existingItems = {
          addresses: stats.existing_addresses || 0,
          offices: stats.existing_offices || 0,
          shifts: stats.existing_shifts || 0,
          paths: stats.existing_paths || 0,
        };

        this.addressesPosted = true;
        this.addressesReady = true;
        this.parsed = false;

        // If new paths were created, update the table and disable the button
        if (stats.new_paths > 0) {
          this.showPaths = true;
          this.postedPaths = response
            .filter((item) => item.path_id)
            .map((item) => ({
              id: item.path_id,
              origin_id: item.origin_id,
              destination_id: item.office_id,
              shift_id: item.shift_id,
            }));
        }

        console.log("New items: ", this.newItems);
        console.log("Existing items: ", this.existingItems);

        // resets values after completion
        this.file = null;
        // this.postedPaths = [];
        // this.selectedColumns = [];
        this.$refs.file.value = null;
      } catch (e) {
        console.warn(
          `Could not post File, message from API: ${(e as Error).message}`,
        );
      } finally {
        this.loading = false;
      }
    },

    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.parseFile();
    },

    parseFile() {
      Papa.parse(this.file, {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          this.parsedData = results.data;
          const headers = Object.keys(this.parsedData[0]);

          // Populate selectedColumns with initial selection
          this.selectedColumns = headers.map((header) => ({
            name: header,
            selected: true,
          }));

          this.csvContent = {
            meta: {
              fields: headers,
            },
            data: this.parsedData,
          };

          this.parsed = true;
          this.currentPage = 1;
        }.bind(this),
      });
    },

    saveSelection() {
      const selectedHeaders = this.selectedColumns
        .filter((column) => column.selected)
        .map((column) => column.name);

      const selectedColumns = this.csvContent.data.map((row) => {
        return Object.fromEntries(
          Object.entries(row).filter(([key]) => selectedHeaders.includes(key)),
        );
      });

      // Update the csvContent immediately
      this.csvContent = {
        meta: {
          fields: selectedHeaders,
        },
        data: selectedColumns,
      };
    },

    onColumnSelectionChange() {
      this.saveSelection();
    },

    addFiles() {
      if (
        this.authStore.hasRole("simple-user") ||
        this.authStore.hasRole("licence-manager")
      ) {
        (this.$refs.file as HTMLInputElement).click();
      }
    },
    getOriginalColumnName(mappedName) {
      if (this.showPaths) {
        const entry = Object.entries(this.columnMapping).find(
          ([_, value]) => value === mappedName,
        );
        return entry ? entry[0] : mappedName;
      }
      return mappedName;
    },
  },
});
</script>

<style>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  display: block;
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}

::file-selector-button {
  visibility: hidden;
}

progress[value] {
  width: 100%;
  height: 20px;
}
</style>
